export default "__VITE_ASSET__U0VjOEiI__"